import { kpiSetService } from '_services';
import { session } from '_helpers';
import { ACTIONS_KPI_SET } from '_constants/kpiSet.constants';
import alertActions from './alert.actions';

export const receiveKpiSets = (kpiSets) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < kpiSets.length; i++) {
    byIdObjectToDispatch[kpiSets[i].machineKPISetID] = kpiSets[i];
  }

  return {
    type: ACTIONS_KPI_SET.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteKpiSet = (kpiSetId) => ({
  type: ACTIONS_KPI_SET.DELETE,
  byId: { [kpiSetId]: null }
});

const getKpiSets = (machineID) => async (dispatch) => {
  try {
    const resp = await kpiSetService.getAll(machineID);
    if (resp?.[0]?.machineKPISetID) {
      dispatch(receiveKpiSets(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving KPIs.', e));
  }
  return null;
};

const getKpiSet = (machineKPISetID) => async (dispatch) => {
  try {
    const resp = await kpiSetService.getById(machineKPISetID);
    if (resp?.machineKPISetID) {
      dispatch(receiveKpiSets([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving KPI #${machineKPISetID}.`, e));
  }
  return null;
};

const addKpiSet = (kpiSet) => async (dispatch) => {
  try {
    const resp = await kpiSetService.create(kpiSet);
    if (resp?.machineKPISetID) {
      dispatch(receiveKpiSets([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updKpiSet = (kpiSet) => async (dispatch) => {
  try {
    const resp = await kpiSetService.update(kpiSet);
    if (resp?.machineKPISetID) {
      dispatch(receiveKpiSets([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delKpiSet = (machineKPISetID) => async (dispatch) => {
  try {
    const resp = await kpiSetService.delete(machineKPISetID);
    if (resp?.machineKPISetID) {
      dispatch(deleteKpiSet(resp.machineKPISetID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing KPI #${machineKPISetID}.`, e));
  }
  return null;
};

export const KpiSetActions = {
  getKpiSets,
  getKpiSet,
  addKpiSet,
  updKpiSet,
  delKpiSet
};

export default KpiSetActions;
